import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getPrettyDate } from "../lib/format";
import { useApi } from "../lib/useApi";
import { programKey } from "../lib/program";

const noPools = { S10Pools: [], S6Pools: [], S13Pools: [], S4Pools: [], S13XPools: [], S1Pools: [], SSPools: [], SCPools: [] };

const PreviewsByPool = () => {
  const location = useLocation();
  const linkStyle = {
    color: "#001489",
    background: "none",
    border: "none",
    padding: 0,
    fontSize: "0.85em",
    fontWeight: "bold",
    cursor: "pointer",
    textDecoration: "none",
  };

  const { data } = useApi(`/api/GetSortedPools`, {
    select: (loaded_pools) => {
      const temp_10 = [],
        temp_6 = [],
        temp_13 = [],
        temp_4 = [],
        temp_13x = [],
        temp_1 = [],
        temp_s = [],
        temp_c = [];
      for (const pool of loaded_pools) {
        if (pool.PartitionKey.startsWith("S10 ")) {
          temp_10.push(pool);
        } else if (pool.PartitionKey.startsWith("S6 ")) {
          temp_6.push(pool);
        } else if (pool.PartitionKey.startsWith("S13 ")) {
          temp_13.push(pool);
        } else if (pool.PartitionKey.startsWith("S4 ")) {
          temp_4.push(pool);
        } else if (pool.PartitionKey.startsWith("S13X ")) {
          temp_13x.push(pool);
        } else if (pool.PartitionKey.startsWith("S1 ")) {
          temp_1.push(pool);
        } else if (pool.PartitionKey.startsWith("SS ")) {
          temp_s.push(pool);
        } else if (pool.PartitionKey.startsWith("SC ")) {
          temp_c.push(pool);
        }
      }
      return {
        S10Pools: temp_10.sort((a, b) => {
          if (a.RowKey < b.RowKey) return -1;
          if (a.RowKey > b.RowKey) return 1;
          return 0;
        }),
        S6Pools: temp_6.sort((a, b) => {
          if (a.RowKey < b.RowKey) return -1;
          if (a.RowKey > b.RowKey) return 1;
          return 0;
        }),
        S13Pools: temp_13.sort((a, b) => {
          if (a.RowKey < b.RowKey) return -1;
          if (a.RowKey > b.RowKey) return 1;
          return 0;
        }),
        S4Pools: temp_4.sort((a, b) => {
          if (a.RowKey < b.RowKey) return -1;
          if (a.RowKey > b.RowKey) return 1;
          return 0;
        }),
        S13XPools: temp_13x.sort((a, b) => {
          if (a.RowKey < b.RowKey) return -1;
          if (a.RowKey > b.RowKey) return 1;
          return 0;
        }),
        S1Pools: temp_1.sort((a, b) => {
          if (a.RowKey < b.RowKey) return -1;
          if (a.RowKey > b.RowKey) return 1;
          return 0;
        }),
        SSPools: temp_s.sort((a, b) => {
          if (a.RowKey < b.RowKey) return -1;
          if (a.RowKey > b.RowKey) return 1;
          return 0;
        }),
        SCPools: temp_c.sort((a, b) => {
          if (a.RowKey < b.RowKey) return -1;
          if (a.RowKey > b.RowKey) return 1;
          return 0;
        }),
      };
    },
  });
  const { S10Pools, S6Pools, S13Pools, S4Pools, S13XPools, S1Pools, SSPools, SCPools } = data ? data : noPools;
  const ContentLoaded = data !== undefined;

  useEffect(() => {
    (async () => {
      // Check if there's a hash in the URL
      if (ContentLoaded && location.hash) {
        const id = location.hash.substring(1);
        // Find the element with the id
        const element = document.getElementById(id);
        // If found, scroll to it
        if (element) {
          setTimeout(() => {
            document.body.style.overflow = "visible";
            element.scrollIntoView({ behavior: "smooth" });
          }, 0);
        }
      }
    })();
  }, [ContentLoaded, location]);

  // The Pool Type sections in page order. Each section links to all the others.
  const sections = [
    { id: "Soccer10", name: "Soccer 10", pools: S10Pools },
    { id: "Soccer6", name: "Soccer 6", pools: S6Pools },
    { id: "Soccer13", name: "Soccer 13", pools: S13Pools },
    { id: "Soccer4", name: "Soccer 4", pools: S4Pools },
    { id: "Soccer13X", name: "Soccer Any 13 Xtra", pools: S13XPools },
    { id: "Soccer1", name: "Soccer 1", pools: S1Pools },
    { id: "SoccerScores", name: "Soccer Scores", pools: SSPools },
    { id: "SoccerCorners", name: "Soccer Corners", pools: SCPools },
  ];

  return (
    <div className="row second">
      <div className="large-12 columns" style={{ paddingLeft: "0.3em" }}>
        <h1>Match Previews - By Pool</h1>
        <p>
          <a
            href="https://www.soccer6.co.za/form-guides/previews"
            style={{
              color: "#001489",
              fontWeight: "bold",
            }}
          >
            Match Previews - Alphabetical / By Kickoff
          </a>
        </p>
        {sections.map((section) => (
          <PreviewSection key={section.id} section={section} others={sections.filter((other) => other !== section)} linkStyle={linkStyle} />
        ))}
      </div>
    </div>
  );
};

const PreviewSection = ({ section, others, linkStyle }) => (
  <section id={section.id}>
    <h4>{`${section.name} Previews`}</h4>
    <br />
    {others.map((other, index) => (
      <React.Fragment key={other.id}>
        {index > 0 && <>&nbsp;|&nbsp;</>}
        <button onClick={() => document.getElementById(other.id).scrollIntoView({ behavior: "smooth" })} style={linkStyle}>
          {other.name}
        </button>
      </React.Fragment>
    ))}
    <br />
    {section.pools.map((item) => (
      <div key={programKey(item)}>
        <section id={item.programDate + "_" + item.programCode + "_" + item.race}>
          <div className="pooldateindicator4R">
            {getPrettyDate(item.programDate)} - {item.PartitionKey}
          </div>
          {item.matches?.map((match, index) => (
            <p key={match.PartitionKey}>
              M{index + 1} {match.RowKey}: {match.preview ?? ""}
            </p>
          ))}
        </section>
      </div>
    ))}
  </section>
);

export default PreviewsByPool;
